import React from 'react';
import Gleap from 'gleap';

import CustomNotification from '../../CustomNotification/CustomNotification';

interface SathiMigrationNotification {
  _id: string;
}

interface Props {
  open: boolean;
  onClose: () => void;
  notification: SathiMigrationNotification;
  onMarkAsRead: (notifications: SathiMigrationNotification[]) => void;
}

const SathiMigrationInterruptedCustomNotification: React.FC<Props> = ({
  open,
  onClose,
  notification,
  onMarkAsRead,
}) => {
  const handleDismiss = () => {
    onMarkAsRead([notification]);
    onClose();
  };

  return (
    <CustomNotification
      open={open}
      onClose={onClose}
      title="Couldn't complete migration"
      message={<p>We couldn&apos;t move your ambassadors to SATHI.</p>}
      actionText="Contact Support"
      avatars={[]}
      icon={<span aria-hidden="true">⚠️</span>}
      autoHideDuration={6000}
      instantClose
      playSound
      handleClickCross={handleDismiss}
      onActionClick={() => {
        handleDismiss();
        Gleap.startConversation();
      }}
    />
  );
};

export default SathiMigrationInterruptedCustomNotification;
